import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ab079d80"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=ab079d80&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppIcon: require('/builds/project/wyffest/frontend/components/app/AppIcon.vue').default,UserEventProgramFilters: require('/builds/project/wyffest/frontend/components/user/event/program/UserEventProgramFilters.vue').default,ProgramSlotCard: require('/builds/project/wyffest/frontend/components/program/ProgramSlotCard.vue').default,AppPagination: require('/builds/project/wyffest/frontend/components/app/AppPagination.vue').default})
